module.exports = __webpack_public_path__ + "static/media/ic-arrow.ecaebf72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Faturation/images/ic-arrow.svg
// module id = 1232
// module chunks = 0